import Splide from '@splidejs/splide';
import '@splidejs/splide/css';

export const initSlider = (container, options = {}) => {
  const sliderElement = container.querySelector('.splide');
  if (!sliderElement) return;

  const splide = new Splide(sliderElement, {
    type: 'slide',
    speed: 1000,
    perMove: 1,
    perPage: 1,
    arrows: false,
    pagination: false,
    updateOnMove: true,
    ...options,
  }).mount();

  const optionsType = splide.options.type;

  const slides = container.querySelectorAll('.splide__slide');
  const arrows = container.querySelectorAll('.arrows');
  const progressbar = container.querySelector('.progressbar__thumb');

  const navigationElems = Array.from(arrows).map(arrow => ({
    next: arrow.querySelector('.arrows__next'),
    prev: arrow.querySelector('.arrows__prev'),
    number: arrow.querySelector('.arrows__number'),
  }));

  const progressIndicators = Array.from(slides)
    .filter(slide => !slide.classList.contains('splide__slide--clone'))
    .map(slide => ({
      slide,
      current: slide.querySelector('.current__slide'),
      total: slide.querySelector('.total__slide'),
    }));

  const getQuantitySlides = () => splide.Components.Elements.slides.length;
  const getPerPage = () => splide.options.perPage;
  // rewind теж зациклює (у fade інакше ніяк) — крайні стрілки не блокувати
  const isLoop = () => splide.options.type === 'loop' || splide.options.rewind;

  // Оновлення стрілок і номеру
  function updateNavigation(currentIndex, totalSlides) {
    const isAtStart = splide.index === 0;
    const isAtEnd = splide.index === splide.Components.Controller.getEnd();

    navigationElems.forEach(({ next, prev, number }) => {
      if (next && prev && !isLoop()) {
        next.disabled = isAtEnd;
        prev.disabled = isAtStart;
        next.classList.toggle('is-disabled', isAtEnd);
        prev.classList.toggle('is-disabled', isAtStart);
      }

      if (number) {
        number.textContent = `${String(currentIndex).padStart(2, '0')}/${String(
          totalSlides
        ).padStart(2, '0')}`;
      }
    });
  }

  // Оновлення лічильників всередині слайдів
  function updateSlideCounters() {
    const quantitySlides = getQuantitySlides();

    progressIndicators.forEach(({ current, total }, index) => {
      const value = String(index + 1).padStart(2, '0');
      const totalValue = String(quantitySlides).padStart(2, '0');

      if (current) {
        current.textContent = value;
      }

      if (total) {
        total.textContent = `${value}/${totalValue}`;
      }
    });
  }

  // Оновлення прогрес-бара
  function updateProgressbar() {
    if (!progressbar) return;

    const quantitySlides = getQuantitySlides();
    const progress =
      (((splide.index + 1) % (quantitySlides + 1)) /
        (quantitySlides + 1 - splide.options.perPage)) *
      100;

    progressbar.style.width = `${progress}%`;
  }

  // Блокування слайдера, якщо слайдів мало
  function handleLockState() {
    const quantitySlides = getQuantitySlides();
    const perPage = getPerPage();
    const shouldLock = quantitySlides <= perPage;

    if (!sliderElement.hasAttribute('data-lock')) return;

    if (shouldLock) {
      splide.Components.Drag.disable(true);
      arrows.forEach(arrow => (arrow.style.display = 'none'));
    } else {
      splide.Components.Drag.mount(true);
      arrows.forEach(arrow => (arrow.style.display = ''));
    }
  }

  // Основна функція оновлення стану слайдера
  function updateSlideState() {
    const quantitySlides = getQuantitySlides();
    const perPage = getPerPage();
    const totalSlides = Math.ceil(quantitySlides / perPage);
    const currentIndex = Math.ceil(splide.index / perPage) + 1;

    updateNavigation(currentIndex, totalSlides);
    updateSlideCounters();
    updateProgressbar();
    handleLockState();
  }

  navigationElems.forEach(({ next, prev }) => {
    next?.addEventListener('click', () => splide.go('>'));
    prev?.addEventListener('click', () => splide.go('<'));
  });

  const eventToUse = optionsType === 'fade' ? 'moved' : 'move';
  splide.on(eventToUse, updateSlideState);

  updateSlideState();
  window.addEventListener('resize', updateSlideState);

  return splide;
};

// <section class="elem">
//   <div class="splide" data-lock>
//     <div class="splide__track">
//       <ul class="splide__list">
//         <li class="splide__slide">
//           <span class="current__slide">01</span>
//           <span class="total__slide">01/02</span>
//           <p>slide 1</p>
//         </li>
//         <li class="splide__slide">
//           <span class="current__slide">02</span>
//           <span class="total__slide">02/02</span>
//           <p>slide 2</p>
//         </li>
//       </ul>
//     </div>
//   </div>

//   <div class="arrows">
//     <div class="arrows__body">
//       <button type="button" class="arrows__prev" aria-label="Arrows prev">
//         <span>Назад</span>
//       </button>
//       <span class="arrows__number">01/02</span>
//       <button type="button" class="arrows__next" aria-label="Arrows next">
//         <span>Далі</span>
//       </button>
//     </div>
//   </div>

//   <div class="progressbar">
//     <div class="progressbar__thumb" aria-label="Progressbar line"></div>
//   </div>
// </section>
